export default __webpack_public_path__ + "static/bg-tech-nation-2-24ad38d21fca162cc8ff87d192b64995.png";